import React from 'react';
import { Alert} from '@amzn/awsui-components-react-v3';

export default function ErrorAlert({dependentProp, children, ...props}) {
  return (
    <div {...props}>
        <Alert onDismiss={() => false} visible={!dependentProp} type="error" header="Error">
            {children}
        </Alert>
    </div>
  );
}